/**
 * Per-bundle lifestyle/education visuals shown on `/products/<bundle-slug>`.
 * Slugs without an entry simply render no gallery.
 */
import rhythmAsset from "@/assets/bundles/calm-sleep-daily-rhythm.png.asset.json";
import pairAsset from "@/assets/bundles/calm-sleep-what-the-pair-adds.png.asset.json";

export interface BundleGalleryImage {
  url: string;
  alt: string;
}

export const BUNDLE_GALLERY: Record<string, BundleGalleryImage[]> = {
  "calm-sleep": [
    {
      url: rhythmAsset.url,
      alt: "A clear daily rhythm — TruWe Liver Biome Plus with breakfast for liver and gut support, Mag Absorb Pro in the evening for sleep and recovery support",
    },
    {
      url: pairAsset.url,
      alt: "What the pair adds — two focused support areas, two routine moments, one simpler daily order with Liver Biome Plus and Mag Absorb Pro",
    },
  ],
};

export function bundleGalleryFor(slug: string): BundleGalleryImage[] {
  return BUNDLE_GALLERY[slug] ?? [];
}
